import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import './index.scss';
import { navigateTo } from '@/Utils/routing';

const KoreanStudyTypeComplete: React.FC = () => {
    const [animationData, setAnimationData] = useState<any>(null);

    useEffect(() => {
        fetch('/animation/Signal_analysis.json')
            .then(response => response.json())
            .then(data => setAnimationData(data))
            .catch(error => console.error('Error loading animation:', error));
    }, []);

    return (
        <div className="korean-study-type-complete-container">
            <div className="content-wrapper">
                {/* Top Section */}
                <div className="top-section">
                    <div className="logo-wrapper">
                        <div className="logo-icon">
                            <img src="/img/matelogoguide.png" alt="MATE Logo" />
                        </div>
                        <span className="logo-text">{"MATE"}</span>
                    </div>
                    <div className="header-section">
                        <h1 className="header-title">{"Korean Language Personality Test"}</h1>
                    </div>
                </div>

                {/* Contents */}
                <div className="contents">
                    <h2 className="complete-title">{"Tes Kepribadian Bahasa Korea MATE selesai!"}</h2>
                    
                    {/* Lottie Animation */}
                    <div className="lottie-container">
                        {animationData && (
                            <Lottie 
                                animationData={animationData} 
                                loop={true}
                                style={{ width: 128, height: 120 }}
                            />
                        )}
                    </div>

                    {/* Icon Badges */}
                    <div className="badges-container">
                        <div className="badges-row">
                            <div className="badge">
                                <img src="/img/type_skill_hunter.svg" alt="Skill Hunter" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_social_butterfly.svg" alt="Social Butterfly" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_k_content_lover.svg" alt="K-Contents Lover" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_si_idol_stan.svg" alt="Idol Stan" />
                            </div>
                        </div>
                        <div className="badges-row offset">
                            <div className="badge">
                                <img src="/img/type_si_paling_estetik.svg" alt="Gamsung" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_si_calon_traveler.svg" alt="Travel" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_si_akademis.svg" alt="Bookman" />
                            </div>
                            <div className="badge">
                                <img src="/img/type_casual_learner.svg" alt="Casual Learner" />
                            </div>
                        </div>
                    </div>

                    {/* Analysis Status */}
                    <div className="analysis-section">
                        <div className="analysis-header">
                            <img src="/svg/Bars.svg" alt="Bars" className="bars-icon" />
                            <span className="analysis-title">{"Sedang menganalisis.."}</span>
                        </div>
                        <p className="analysis-description">
                            {`Sedang menganalisis gaya belajar bahasa Korea kamu.
                            |Sambil menunggu, yuk ikut survei singkat!
                            |Surveinya cuma butuh 30 detik!`.replace(/\n *\|/g, '\n')}
                        </p>
                        <p className="skip-text">{"Kalau mau, kamu bisa lewati survei ini"}</p>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
                <div className="cta-wrapper">
                    <button
                        className="btn-next"
                        onClick={()=> navigateTo(`/personatest/koreanstudytype/survey`)}
                    >{"Isi survey dan lihat hasilnya"}</button>
                </div>
            </div>
        </div>
    );
};

export default KoreanStudyTypeComplete;
